import { GET_CUSTOMER_CONTACTS } from './getCustomerContacts';
import { GET_CUSTOMER_CREDIT_APPS } from './getCustomerCreditApps';
import { GET_CUSTOMER_DETAILS } from './getCustomerDetails';
import { GET_CUSTOMER_DOCUMENTS } from './getCustomerDocuments';
import { GET_CUSTOMER_OPPORTUNITIES } from './getCustomerOpportunities';
import { GET_CUSTOMER_PROPOSALS } from './getCustomerProposals';
import { GET_CUSTOMERS } from './getCustomers';

export const customersApi = {
  // Customers List
  getCustomers: GET_CUSTOMERS,

  // General tab
  getCustomerDetails: GET_CUSTOMER_DETAILS,
  getCustomerContacts: GET_CUSTOMER_CONTACTS,
  getCustomerOpportunities: GET_CUSTOMER_OPPORTUNITIES,
  getCustomerProposals: GET_CUSTOMER_PROPOSALS,

  // Credit Apps tab
  getCustomerCreditApps: GET_CUSTOMER_CREDIT_APPS,

  // Documents tab
  getCustomerDocuments: GET_CUSTOMER_DOCUMENTS,
};
